/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { IEditor } from "../../IEditor";
import { termsEditorCommon as terms } from "../../terms/common";

export function DemoModule(dc: IEditor): void {
	dc.get("logger").debug("Demo module enabled.");

	const menuSvc = dc.get("menuService");

	// -- Create

	menuSvc.registerMenuItem("main.create", {
		id: "actionTrigger",
		label: terms.mainMenu.sectionCreate.actionTrigger.label,
		tooltip: terms.mainMenu.sectionCreate.actionTrigger.tooltip,
		icon: "mdi/lightning-bolt",
		flags: [ "primary", "comingSoon" ],
		order: 30,
		commandId: "resource.createActionTrigger"
	});

	menuSvc.registerMenuItem("main.create", {
		id: "modelEntity",
		label: terms.mainMenu.sectionCreate.modelEntity.label,
		tooltip: terms.mainMenu.sectionCreate.modelEntity.tooltip,
		icon: "mdi/database",
		flags: [ "primary", "comingSoon" ],
		order: 40,
		commandId: "resource.createModelEntity"
	});

	menuSvc.registerMenuItem("main.create", {
		id: "widget",
		label: terms.mainMenu.sectionCreate.widget.label,
		tooltip: terms.mainMenu.sectionCreate.widget.tooltip,
		icon: "mdi/widgets",
		flags: [ "primary", "comingSoon" ],
		order: 60,
		commandId: "resource.createWidget"
	});

	menuSvc.registerMenuItem("main.create", {
		id: "function",
		label: terms.mainMenu.sectionCreate.function.label,
		tooltip: terms.mainMenu.sectionCreate.function.tooltip,
		icon: "mdi/function-variant",
		flags: [ "primary", "comingSoon" ],
		order: 80,
		commandId: "resource.createFunction"
	});

	// -- Manage

	menuSvc.registerMenuItem("main.manage", {
		id: "translations",
		label: terms.mainMenu.sectionManage.translations.label,
		tooltip: terms.mainMenu.sectionManage.translations.tooltip,
		icon: "mdi/translate",
		flags: [ "comingSoon" ],
		order: 20,
		commandId: "translations.open"
	});

	menuSvc.registerMenuItem("main.manage", {
		id: "packages",
		label: terms.mainMenu.sectionManage.packages.label,
		tooltip: terms.mainMenu.sectionManage.packages.tooltip,
		icon: "mdi/package-variant",
		flags: [ "comingSoon" ],
		order: 50,
		commandId: "packages.open"
	});

	menuSvc.registerMenuItem("main.manage", {
		id: "externalLibs",
		label: terms.mainMenu.sectionManage.externalLibs.label,
		tooltip: terms.mainMenu.sectionManage.externalLibs.tooltip,
		icon: "mdi/code-braces-box",
		flags: [ "comingSoon" ],
		order: 60,
		commandId: "externalLibs.open"
	});

	// -- Monitor

	menuSvc.registerMenuItem("main.monitor", {
		id: "diagnostics",
		label: terms.mainMenu.sectionMonitor.diagnostics.label,
		tooltip: terms.mainMenu.sectionMonitor.diagnostics.tooltip,
		icon: "mdi/stethoscope",
		flags: [],
		order: 10,
		commandId: "diagnostics.open"
	});

	menuSvc.registerMenuItem("main.monitor", {
		id: "logs",
		label: terms.mainMenu.sectionMonitor.logs.label,
		tooltip: terms.mainMenu.sectionMonitor.logs.tooltip,
		icon: "mdi/post",
		flags: [],
		order: 30,
		commandId: "envLogs.open"
	});

	menuSvc.registerMenuItem("main.monitor", {
		id: "stats",
		label: terms.mainMenu.sectionMonitor.stats.label,
		tooltip: terms.mainMenu.sectionMonitor.stats.tooltip,
		icon: "mdi/gauge",
		flags: [ "comingSoon" ],
		order: 40,
		commandId: "appStats.open"
	});

	// -- Tools

	menuSvc.registerMenuItem("main.tools", {
		id: "smartTemplates",
		label: terms.mainMenu.sectionTools.smartTemplates.label,
		tooltip: terms.mainMenu.sectionTools.smartTemplates.tooltip,
		icon: "mdi/robot",
		flags: [ "comingSoon" ],
		order: 10,
		commandId: "smartTemplates.open"
	});

	menuSvc.registerMenuItem("main.tools", {
		id: "importOpenApi",
		label: terms.mainMenu.sectionTools.importOpenApi.label,
		tooltip: terms.mainMenu.sectionTools.importOpenApi.tooltip,
		icon: "mdi/api",
		flags: [ "comingSoon" ],
		order: 20,
		commandId: "importOpenApi.open"
	});

	// -- Documentation
}
